function initCartDrawer() {
    if (window.__mtbdCartDrawerInitialized) return;
    window.__mtbdCartDrawerInitialized = true;

    const cartDrawer = document.getElementById('cart-drawer');
    const cartOverlay = document.getElementById('cart-overlay');
    const cartInner = document.getElementById('cart-drawer-inner');
    const CROSS_SELL_VIEW_THRESHOLD = 0.5;
    const CROSS_SELL_VIEW_DWELL_MS = 400;

    let listenersAdded = false;
    let lastFreeShippingStateThisOpen = null;
    let crossSellViewedThisOpen = false;
    let crossSellImpressedThisOpen = false;
    let crossSellViewObserver = null;
    let crossSellViewTimer = null;

    function trackClarityCartEvent(action, detail = {}) {
      if (window.aoClarity && typeof window.aoClarity.trackCartEvent === 'function') {
        window.aoClarity.trackCartEvent(action, detail);
      } else if (typeof window.clarityTrack === 'function') {
        if (action === 'open') {
          const context = normalizeCartOpenContext(detail);
          if (typeof window.clarity === 'function') {
            window.clarity('set', 'cart_surface', context.surface);
            window.clarity('set', 'cart_open_type', context.type);
            window.clarity('set', 'cart_open_source', context.source);
          }

          window.clarityTrack('cart_open');
          return;
        }

        if (action === 'close') {
          if (detail.source && typeof window.clarity === 'function') {
            window.clarity('set', 'cart_close_source', detail.source);
          }

          window.clarityTrack('cart_close');
          return;
        }

        window.clarityTrack(action);
      }
    }

    function getCartFreeShippingEventName() {
      const stateEl = cartDrawer.querySelector('[data-cart-free-shipping-state]');
      if (!stateEl) return null;

      if (stateEl.dataset.itemCount === '0') {
        return 'cart_emptied';
      }

      if (stateEl.dataset.freeShippingMode === 'hidden') return null;
      if (stateEl.dataset.freeShippingMode === 'message' && stateEl.dataset.hasHeavyBulky !== 'true') return 'cart_free_shipping_no_minimum';
      if (stateEl.dataset.hasHeavyBulky === 'true') {
        return 'cart_free_shipping_blocked_heavy_bulky';
      }

      if (stateEl.dataset.freeShippingUnlocked === 'true') {
        return 'cart_free_shipping_threshold_met';
      }

      return 'cart_free_shipping_threshold_not_met';
    }

    function getCartStateRoot() {
      return cartDrawer.querySelector('[data-cart-free-shipping-state]');
    }

    function getCartFreeShippingState() {
      const stateEl = getCartStateRoot();
      if (!stateEl) return 'not_met';

      if (stateEl.dataset.freeShippingMode === 'hidden') return 'hidden';
      if (stateEl.dataset.freeShippingMode === 'message' && stateEl.dataset.hasHeavyBulky !== 'true') return 'no_minimum';
      if (stateEl.dataset.hasHeavyBulky === 'true') {
        return 'blocked';
      }

      return stateEl.dataset.freeShippingUnlocked === 'true' ? 'met' : 'not_met';
    }

    function getCartValueBand(totalCents) {
      const totalDollars = Math.max(0, Math.floor(Number(totalCents || 0) / 100));

      if (totalDollars >= 400) {
        return '400_plus';
      }

      const lower = Math.floor(totalDollars / 50) * 50;
      const upper = lower + 49;

      return `${lower}_${upper}`;
    }

    function getCartStateTags() {
      const stateEl = getCartStateRoot();
      if (!stateEl) return null;

      const totalCents = Number(stateEl.dataset.cartTotal || 0);
      const itemCount = Number(stateEl.dataset.itemCount || 0);
      const hasCrossSellsNow = Boolean(cartDrawer.querySelector('[data-cart-cross-sell-root]'));

      return {
        freeShippingState: getCartFreeShippingState(),
        valueBand: getCartValueBand(totalCents),
        itemCount,
        total: (totalCents / 100).toFixed(2),
        hasCrossSells: hasCrossSellsNow,
        hasHeavyBulky: stateEl.dataset.hasHeavyBulky === 'true',
        hasDropship: stateEl.dataset.hasDropship === 'true',
        pricingMix: stateEl.dataset.cartPricingMix || 'full_price'
      };
    }

    function setClarityCartStateTags() {
      const tags = getCartStateTags();
      if (!tags) return;

      if (window.aoClarity && typeof window.aoClarity.setCartState === 'function') {
        window.aoClarity.setCartState(tags);
      } else if (typeof window.clarity === 'function') {
        window.clarity('set', 'cart_free_shipping_state', String(tags.freeShippingState));
        window.clarity('set', 'cart_value_band', String(tags.valueBand));
        window.clarity('set', 'cart_item_count', String(tags.itemCount));
        window.clarity('set', 'cart_total', String(tags.total));
        window.clarity('set', 'cart_has_cross_sells', String(tags.hasCrossSells));
        window.clarity('set', 'cart_has_heavy_bulky', String(tags.hasHeavyBulky));
        window.clarity('set', 'cart_has_dropship', String(tags.hasDropship));
        window.clarity('set', 'cart_pricing_mix', String(tags.pricingMix));
      }
    }

    function trackClarityCartState() {
      const eventName = getCartFreeShippingEventName();
      if (!eventName) return;

      if (lastFreeShippingStateThisOpen === null) {
        lastFreeShippingStateThisOpen = eventName;
        return;
      }

      if (lastFreeShippingStateThisOpen === eventName) return;

      lastFreeShippingStateThisOpen = eventName;

      if (window.aoClarity && typeof window.aoClarity.trackCartDrawerState === 'function') {
        window.aoClarity.trackCartDrawerState(cartDrawer);
      } else if (typeof window.clarityTrack === 'function') {
        window.clarityTrack(eventName);
      }
    }

    function normalizeCartOpenContext(context = {}) {
      return {
        surface: 'drawer',
        type: context.type || 'unknown',
        source: context.source || 'unknown'
      };
    }

    function trackCartDrawerOpen(context = {}) {
      if (context.track === false) return;

      trackClarityCartEvent('open', normalizeCartOpenContext(context));
    }

    function openCartDrawer(context = {}) {
        const wasOpen = cartDrawer.classList.contains('open');

        if (!wasOpen) {
          lastFreeShippingStateThisOpen = null;
          crossSellViewedThisOpen = false;
          crossSellImpressedThisOpen = false;
        }

        document.documentElement.classList.remove('cart-overlay-active');

        // Add cart event listener
        addEventListeners();

        // Drop chat button z-index
        const gorgiasBtn = document.getElementById('chat-button');
        if (gorgiasBtn) gorgiasBtn.style.zIndex = '1';

        // Show drawer and overlay immediately
        cartDrawer.classList.add('open');
        cartOverlay.classList.remove('hidden');
        cartOverlay.classList.add('visible');
        document.body.classList.add('no-scroll');

        if (!wasOpen) {
          trackCartDrawerOpen(context);
        }

        // Then load cart content
        fetchCartContent();
    }
    window.openCartDrawer = openCartDrawer; // Expose function globally. Used in cart-notification.js to open the drawer.
    
    function closeCartDrawer(context = {}) {
        const wasOpen = cartDrawer.classList.contains('open');

        if (wasOpen && context.source) {
          trackClarityCartEvent('close', { source: context.source });
        }

        cartDrawer.classList.remove('open');
        cartOverlay.classList.remove('visible');
        cartOverlay.classList.add('hidden');
        
        closeCartCrossSellOverlay();
        disconnectCrossSellViewObserver();

        cartInner.innerHTML = ''; // Clear content

        document.body.classList.remove('no-scroll');
        document.documentElement.classList.remove('cart-overlay-active');
        
        const gorgiasBtn = document.getElementById('chat-button');
        if (gorgiasBtn) gorgiasBtn.style.zIndex = '2147483636';
    }

    function fetchCartContent() {
      fetch('/?section_id=cart-drawer')
        .then(res => res.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const content = doc.getElementById('shopify-section-cart-drawer');
          if (!content) return;

          // Inject cart content
          cartInner.innerHTML = content.innerHTML;
          cartCrossSellGroups = null; // ✅ reset cross-sell overlay cache after re-render
          cartPromotionalOffers = null;
          promotionalOffersExpanded = false;

          setTimeout(() => {
            document.querySelectorAll('.cart-drawer__cross-sells-wrapper')
              .forEach(wrapper => updateCrossSellNavState(wrapper));
          }, 50);

          // Auto-focus checkout button and init shipping
          const checkoutBtn = cartDrawer.querySelector('#checkout');
          if (checkoutBtn) {
            checkoutBtn.focus();
          }

          initCartPromotionalOffers();

          updateCartIconCount();
          setClarityCartStateTags();
          trackClarityCartState();
          trackCartCrossSellImpression();
          observeCartCrossSellView();
        });
    }

    function trackCartCrossSellImpression() {
      if (crossSellImpressedThisOpen) return;

      const crossSellRoot = cartDrawer.querySelector('[data-cart-cross-sell-root]');
      if (!crossSellRoot) return;

      crossSellImpressedThisOpen = true;
      trackClarityCartEvent('cross_sell_impression');
    }

    function disconnectCrossSellViewObserver() {
      clearCrossSellViewTimer();

      if (!crossSellViewObserver) return;

      crossSellViewObserver.disconnect();
      crossSellViewObserver = null;
    }

    function clearCrossSellViewTimer() {
      if (!crossSellViewTimer) return;

      clearTimeout(crossSellViewTimer);
      crossSellViewTimer = null;
    }

    function startCrossSellViewTimer() {
      if (crossSellViewTimer || crossSellViewedThisOpen) return;

      crossSellViewTimer = setTimeout(() => {
        crossSellViewTimer = null;
        if (crossSellViewedThisOpen) return;

        crossSellViewedThisOpen = true;
        trackClarityCartEvent('cross_sell_view');
        disconnectCrossSellViewObserver();
      }, CROSS_SELL_VIEW_DWELL_MS);
    }

    function observeCartCrossSellView() {
      disconnectCrossSellViewObserver();

      if (crossSellViewedThisOpen) return;

      const crossSellRoot = cartDrawer.querySelector('[data-cart-cross-sell-root]');
      if (!crossSellRoot) return;

      if (typeof IntersectionObserver !== 'function') {
        crossSellViewedThisOpen = true;
        trackClarityCartEvent('cross_sell_view');
        return;
      }

      crossSellViewObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (crossSellViewedThisOpen) return;

          if (entry.isIntersecting && entry.intersectionRatio >= CROSS_SELL_VIEW_THRESHOLD) {
            startCrossSellViewTimer();
          } else {
            clearCrossSellViewTimer();
          }
        });
      }, {
        root: cartDrawer,
        threshold: CROSS_SELL_VIEW_THRESHOLD
      });

      crossSellViewObserver.observe(crossSellRoot);
    }
    
    function updateCartIconCount() {
      const countBubble = document.querySelector('.cart-count-bubble');
      if (!countBubble) return;

      let count = 0;
      const subtotalRow = document.querySelector('.cart-drawer__row--subtotal');
      
      if (subtotalRow) {
        // Get items count from the subtotal row
        count = subtotalRow.dataset.itemsCount || 0;
      } 

      const spanVisible = countBubble.querySelector('span[aria-hidden="true"]');
      const spanScreenReader = countBubble.querySelector('span.visually-hidden');

      if (spanVisible) spanVisible.innerText = count;
      if (spanScreenReader) spanScreenReader.innerText = `${count} item${count === 1 ? '' : 's'}`;
    
    }

    // Bind to cart icon
    const cartTrigger = document.querySelector('[data-drawer-toggle="cart"]');
    if (cartTrigger) {
        cartTrigger.addEventListener('click', function (e) {
            const cartUrl = new URL(cartTrigger.href, window.location.origin);
            const normalizePath = (path) => path.replace(/\/$/, '') || '/';
            const isCartPage = normalizePath(window.location.pathname) === normalizePath(cartUrl.pathname);

            if (isCartPage) {
              e.preventDefault();
              window.location.reload();
              return;
            }

            e.preventDefault();
            openCartDrawer({ type: 'manual', source: 'header' });
        });
    }

    function addEventListeners() {
      if (listenersAdded) return;
      listenersAdded = true;

      // Overlay click closes drawer
      cartOverlay.addEventListener('click', () => closeCartDrawer({ source: 'overlay' }));

      // Header close button click closes drawer
      document.addEventListener('click', function (e) {
          const checkoutBtn = e.target.closest('#checkout, .cart__checkout-button, [name="checkout"]');
          if (checkoutBtn && cartDrawer.contains(checkoutBtn)) {
              setClarityCartStateTags();
              trackClarityCartEvent('checkout');
              return;
          }

          if (e.target.id === 'cart-drawer-close') {
              closeCartDrawer({ source: 'icon' });
          }
      });

      // ESC key closes drawer
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;

        if (!cartDrawer.classList.contains('open')) return;

        const { overlay } = getCartProductPickerElements();

        // ✅ If overlay is open → close ONLY overlay
        if (overlay && !overlay.hidden) {
          closeCartCrossSellOverlay();
          return;
        }

        // ✅ Otherwise → close cart
        closeCartDrawer();
      });


      // Trap focus inside cart drawer when open
      document.addEventListener('keydown', function (e) {
          if (!cartDrawer.classList.contains('open')) return;

          const focusableSelectors = [
              'a[href]',
              'button:not([disabled])',
              'textarea:not([disabled])',
              'input:not([disabled])',
              'select:not([disabled])',
              '[tabindex]:not([tabindex="-1"])'
          ];
          const focusableElements = cartDrawer.querySelectorAll(focusableSelectors.join(', '));
          if (focusableElements.length === 0) return;

          const first = focusableElements[0];
          const last = focusableElements[focusableElements.length - 1];

          // Trap Tab key
          if (e.key === 'Tab') {
              if (e.shiftKey && document.activeElement === first) {
                  e.preventDefault();
                  last.focus();
              } else if (!e.shiftKey && document.activeElement === last) {
                  e.preventDefault();
                  first.focus();
              }
          }
      });

      // Handle remove item clicks
      document.addEventListener('click', function (e) {
        const removeBtn = e.target.closest('.cart-drawer__remove');
        if (!removeBtn) return;

        e.preventDefault();
        removeBtn.classList.add('cart-drawer__remove--loading');

        const line = removeBtn.getAttribute('data-line');
        const item = removeBtn.closest('.cart-drawer__item');
        const trackingDetail = {
          line: Number(line),
          variantId: removeBtn.dataset.variantId || item?.dataset.variantId,
          sku: removeBtn.dataset.sku || item?.dataset.sku,
          productTitle: removeBtn.dataset.productTitle || item?.dataset.title,
          quantity: Number(item?.dataset.quantity || 0)
        };

        // Disable all remove buttons
        document.querySelectorAll('.cart-drawer__remove').forEach(btn => btn.disabled = true);

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: 0 })
        })
          .then(res => res.json())
          .then(() => {
            trackClarityCartEvent('remove', trackingDetail);
            fetchCartContent();
            document.querySelectorAll('.cart-drawer__remove').forEach(btn => btn.disabled = false);
          });
      });

      // Handle quantity changes
      document.addEventListener('change', function (e) {
          if (e.target.matches('.cart-drawer__quantity-select')) {
              const line = e.target.getAttribute('data-line');
              const previousQuantity = parseInt(e.target.dataset.currentQuantity || '0', 10);
              const quantity = parseInt(e.target.value, 10);
              const direction = quantity > previousQuantity ? 'increase' : quantity < previousQuantity ? 'decrease' : 'change';
              const item = e.target.closest('.cart-drawer__item');
              const trackingDetail = {
                line: Number(line),
                previousQuantity,
                quantity,
                direction,
                variantId: e.target.dataset.variantId || item?.dataset.variantId,
                sku: e.target.dataset.sku || item?.dataset.sku,
                productTitle: e.target.dataset.productTitle || item?.dataset.title
              };

              fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ line: Number(line), quantity: quantity })
              })
                  .then(res => res.json())
                  .then(() => {
                      trackClarityCartEvent('quantity', trackingDetail);
                      // Refresh cart drawer
                      fetchCartContent();
                  });
          }
      });

      // Order references
      document.addEventListener('click', function (e) {
        if (e.target.matches('.edit-order-reference')) {
          e.preventDefault();
          const itemKey = e.target.getAttribute('data-order-ref-key');
          const currentReference = e.target.getAttribute('data-order-ref-value') || '';

          editOrderReference(itemKey, currentReference);
        }
      });
      async function editOrderReference(itemKey, currentReference) {
          const input = prompt("Add, edit or remove your order reference(s):", currentReference);
          if (input === null) {
              // User cancelled the prompt, do nothing
              return;
          }

          const newReference = input?.trim();

          // Fetch the cart to get the line item by key
          const cart = await fetch('/cart.js').then(res => res.json());
          const lineItem = cart.items.find(item => item.key === itemKey);
          if (!lineItem) {
              return;
          }

          const existingProperties = { ...(lineItem.properties || {}) };
          if (!newReference || newReference === '') {
              existingProperties['Order Reference(s)'] = "";
          } else {
              existingProperties['Order Reference(s)'] = newReference;
          }

          const updates = {'id': itemKey, 'quantity': lineItem.quantity, 'properties': existingProperties};

          // Perform the fetch request
          fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify(updates)
          })
          .then(response => {
              if (response.ok) {
                  return response.json();
              } else {
                  throw new Error(`Cart line item properties update failed. ${response.statusText} ${response.status}`);
              }
          })
          .then((data) => {
              openCartDrawer({ track: false }); // Refresh the cart drawer
          })
          .catch((error) => {
              console.error('Error:', error, JSON.stringify(updates));
          });
      }

      // Postcode input & change event
      document.addEventListener('input', function (e) {
        if (e.target.matches('.cart-drawer__postcode-input')) {
          // Handle input event for postcode
          e.target.value = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
          if (e.target.value.length > 4) {
            e.target.value = e.target.value.slice(0, 4); // Limit to 4 characters
          }
        }
      });

      document.addEventListener('change', async function (e) {
        if (e.target.matches('.cart-drawer__postcode-input')) {
          e.preventDefault();

          const shippingCost = document.querySelector('.cart-drawer__shipping-cost'); 
          if (shippingCost) {
            shippingCost.classList.add('shimmer');  
            shippingCost.innerText = '&nbsp;'; // Show shimmer effect}
          }
          
          // Handle change event for postcode
          const postcode = e.target.value;

          // Save postcode to local storage
          address.zip = postcode;
          address.city = null; // Reset city as postcode has changed
          address.province = null; // Reset province as postcode has changed
          address.country = null; // Reset country as postcode has changed  

          await getPostcodeDetails(postcode);
          addressIsComplete = () => address.city?.trim() && address.zip?.trim() && address.province?.trim() && address.country?.trim();
          if (addressIsComplete()) {
            getShippingRates(address);
          } 
          else {
            // Display postcode input box
            document.querySelector('.cart-drawer__row--shipping-postcode').classList.remove('hidden');
            const shippingCost = document.querySelector('.cart-drawer__shipping-cost'); 
            if (shippingCost) {
              shippingCost.classList.remove('shimmer');  
              shippingCost.innerText = 'Enter a valid postcode';
              renderRates([]); // Clear rates display
            }
          }
        }
      });

      // 🚀 ENTER key triggers 'change' manually
      document.addEventListener('keydown', function (e) {
        if (e.target.matches('.cart-drawer__postcode-input') && e.key === 'Enter') {
          e.preventDefault();
          const changeEvent = new Event('change', { bubbles: true });
          e.target.dispatchEvent(changeEvent);
        }
      });
      
      document.addEventListener('click', async function (e) {
        const btn = e.target.closest('[data-cross-sell-add]');
        if (!btn) return;

        e.preventDefault();

        if (btn.classList.contains('is-loading') || btn.disabled) return;

        btn.classList.add('is-loading');

        try {
          const badges = parseCrossSellBadges(btn.dataset.crossSellBadges);
          await addCrossSellVariant(btn.dataset.variantId, btn.dataset.crossSellPosition, { badges });
          trackClarityCartEvent('cross_sell_atc', {
            variantId: btn.dataset.variantId,
            position: btn.dataset.crossSellPosition || 'card'
          });
          fetchCartContent(); // Re-render cart drawer so item disappears from cross-sells
        } catch (error) {
          console.error('Cross-sell add failed', error);
          btn.classList.remove('is-loading');
        }
      });
      document.addEventListener('click', function (e) {
        const nav = e.target.closest('[data-cross-sell-nav]');
        if (!nav) return;
        const direction = nav.dataset.crossSellNav;
        const wrapper = nav.closest('.cart-drawer__cross-sells-wrapper');
        if (!wrapper) return;
        const track = wrapper.querySelector('[data-cross-sell-track]');
        if (!track) return;

        // Scroll amount = ~1 card width
        const card = track.querySelector('.cart-drawer__cross-sell-card');
        if (!card) return;

        const scrollAmount = card.offsetWidth + 12; // 12 = gap

        if (direction === 'right') {
          track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        }

        trackClarityCartEvent('cross_sell_nav', { direction });
      });
      document.addEventListener('scroll', function (e) {
        if (!(e.target instanceof Element)) return;

        const track = e.target.closest('[data-cross-sell-track]');
        if (!track) return;

        const wrapper = track.closest('.cart-drawer__cross-sells-wrapper');
        if (!wrapper) return;

        updateCrossSellNavState(wrapper);
      }, true);
      // ✅ Cross-sell overlay open/close
      document.addEventListener('click', function (e) {
        const openBtn = e.target.closest('[data-cross-sell-open]');
        if (openBtn) {
          e.preventDefault();

          const groups = getCartCrossSellData();
          const parent = (openBtn.dataset.crossSellParent || '').trim();
          const group = groups?.find(g => (g.parent || '').trim() === parent);
          
          trackClarityCartEvent('cross_sell_open', {
            parent,
            variantId: openBtn.dataset.variantId,
            productId: openBtn.dataset.productId,
            sku: openBtn.dataset.sku
          });
          openCartCrossSellOverlay(group);
          return;
        }

        if (e.target.closest('[data-cart-cross-sell-close]')) {
          closeCartCrossSellOverlay();
        }
        
        const overlay = document.querySelector('[data-cart-cross-sell-overlay]');
        const dialog = overlay?.querySelector('.cart-cross-sell-overlay__dialog');

        if (overlay && !overlay.hidden && dialog) {
          const clickedInsideDialog = e.target.closest('.cart-cross-sell-overlay__dialog');

          if (!clickedInsideDialog) {
            closeCartCrossSellOverlay();
          }
        }
      });
      document.addEventListener('click', function (e) {
        if (e.target.closest('.cart-drawer::after')) {
          closeCartCrossSellOverlay();
        }
      });
    }

    ////////////////////////////////////////////////////////
    // Cart promotional offers
    ////////////////////////////////////////////////////////
    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function applyPromotionalOfferPricing(item, offer) {
      const pricedItem = { ...item, discount_type: offer.offer_type };

      if (offer.offer_type === 'free_gift') {
        return {
          ...pricedItem,
          price_original: item.price_final,
          price_final: 'Free'
        };
      }

      const basePriceCents = Number(item.price_cents || 0);
      const discountAmountCents = Number(offer.discount_amount_cents || 0);
      const discountPercentage = Number(offer.discount_percentage || 0);

      if (!basePriceCents || (!discountAmountCents && !discountPercentage)) {
        return pricedItem;
      }

      const discountedPriceCents = discountAmountCents
        ? Math.max(0, basePriceCents - discountAmountCents)
        : Math.max(
            0,
            Math.round(basePriceCents * (1 - discountPercentage / 100))
          );

      return {
        ...pricedItem,
        price_original: item.price_final,
        price_final: formatMoney(discountedPriceCents),
        price_save: formatMoney(basePriceCents - discountedPriceCents)
      };
    }

    function normalizeDiscountTitle(title) {
      return String(title || '').trim().toLowerCase();
    }

    function nonStackableDiscountTitles() {
      const wrapper = cartDrawer.querySelector('[data-cart-promotional-offers]');
      const rawTitles = wrapper?.dataset.nonStackableDiscounts || '';

      return rawTitles
        .split(/[\n,]+/)
        .map(normalizeDiscountTitle)
        .filter(Boolean);
    }

    function appliedDiscountTitles(cart) {
      const titles = [];

      cart.cart_level_discount_applications?.forEach(discount => {
        titles.push(discount.title);
      });

      cart.items?.forEach(item => {
        item.line_level_discount_allocations?.forEach(allocation => {
          titles.push(allocation.discount_application?.title);
        });

        item.discounts?.forEach(discount => {
          titles.push(discount.title);
        });
      });

      return titles.map(normalizeDiscountTitle).filter(Boolean);
    }

    function hasNonStackableDiscountApplied(cart) {
      const blockedTitles = nonStackableDiscountTitles();
      if (!blockedTitles.length) return false;

      const activeTitles = appliedDiscountTitles(cart);
      return activeTitles.some(title => blockedTitles.includes(title));
    }

    async function fetchCartJson() {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      return res.json();
    }

    async function addPromotionalOfferVariant(variantId, offerHandle) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1,
              properties: { _cart_promotional_offer: offerHandle }
            }
          ]
        })
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        console.warn('Promotional offer could not be added:', err);
        throw new Error('Promotional offer add failed');
      }
    }

    async function loadCollectionOfferItems(offer) {
      if (offer.collectionItemsLoaded) return offer.group?.items || [];

      const items = [...(offer.group?.items || [])];
      const seenVariantIds = new Set(items.map((item) => String(item.variant_id)));
      const collectionHandles = offer.offered_collection_handles || [];

      for (const handle of collectionHandles) {
        let page = 1;
        const loadedPages = new Set();

        while (page && !loadedPages.has(page)) {
          loadedPages.add(page);

          const params = new URLSearchParams({
            section_id: 'cart-promotional-offer-products',
            'filter.v.availability': '1',
            page: String(page)
          });
          const response = await fetch(
            `/collections/${encodeURIComponent(handle)}?${params.toString()}`,
            { headers: { Accept: 'text/html' } }
          );
          if (!response.ok) break;

          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const dataEl = doc.querySelector('[data-cart-promotional-collection-products]');
          if (!dataEl) break;

          let payload = {};
          try {
            payload = JSON.parse(dataEl.textContent || '{}');
          } catch (error) {
            console.warn('Promotional collection product JSON parse failed', error);
          }

          const collectionItems = Array.isArray(payload)
            ? payload
            : (payload.items || []);

          collectionItems.forEach((item) => {
            if (seenVariantIds.has(String(item.variant_id))) return;

            seenVariantIds.add(String(item.variant_id));
            items.push(applyPromotionalOfferPricing(item, offer));
          });

          page = Array.isArray(payload) ? 0 : Number(payload.next_page || 0);
        }
      }

      offer.collectionItemsLoaded = true;
      if (offer.group) offer.group.items = items;
      return items;
    }

    function getCartPromotionalOffers() {
      if (cartPromotionalOffers) return cartPromotionalOffers;

      cartPromotionalOffers = Array.from(
        cartDrawer.querySelectorAll('[data-cart-promotional-offer-data]')
      )
        .map((dataEl) => {
          try {
            const offer = JSON.parse(dataEl.textContent || '{}');
            if (offer.group?.items) {
              offer.group.items = offer.group.items.map((item) =>
                applyPromotionalOfferPricing(item, offer)
              );
            }
            return offer;
          } catch (error) {
            console.warn('Cart promotional offer JSON parse failed', error);
            return null;
          }
        })
        .filter(Boolean)
        .sort((a, b) => Number(b.priority || 0) - Number(a.priority || 0));

      return cartPromotionalOffers;
    }

    function normalizeResourceIds(ids) {
      return new Set((ids || []).map((id) => String(id)));
    }

    function getOfferCartState(cart, offer) {
      const offeredProductIds = normalizeResourceIds(offer.offered_product_ids);
      const qualifyingProductIds = normalizeResourceIds([
        ...(offer.qualifying_product_ids || []),
        ...(offer.qualifying_collection_cart_product_ids || [])
      ]);
      const hasProductQualifiers = offer.has_product_qualifiers === true;

      const qualifyingLines = (cart.items || []).filter((item) => {
        const productId = String(item.product_id);
        if (offeredProductIds.has(productId)) return false;
        return !hasProductQualifiers || qualifyingProductIds.has(productId);
      });

      const qualifyingSubtotalCents = qualifyingLines.reduce(
        (sum, item) => sum + Number(item.final_line_price || 0),
        0
      );
      const qualifyingQuantity = qualifyingLines.reduce(
        (sum, item) => sum + Number(item.quantity || 0),
        0
      );
      const minimumSpendCents = Number(offer.minimum_spend_cents || 0);
      const minimumQuantity = Number(offer.qualifying_quantity || 0);

      return {
        eligible:
          (!minimumSpendCents || qualifyingSubtotalCents >= minimumSpendCents) &&
          (!minimumQuantity || qualifyingQuantity >= minimumQuantity),
        qualifyingSubtotalCents,
        hasOfferedProduct: (cart.items || []).some((item) =>
          offeredProductIds.has(String(item.product_id))
        )
      };
    }

    function hasExpectedDiscountApplied(cart, offer) {
      const expectedTitle = normalizeDiscountTitle(offer.expected_discount_title);
      if (!expectedTitle) return false;
      return appliedDiscountTitles(cart).includes(expectedTitle);
    }

    function updateCartPromotionalOfferUI(cart, offer) {
      const offerEl = cartDrawer.querySelector(
        `[data-cart-promotional-offer="${CSS.escape(offer.handle)}"]`
      );
      if (!offerEl) return;

      const state = getOfferCartState(cart, offer);
      const isFreeGift = offer.offer_type === 'free_gift';
      const hasBlockedDiscount = isFreeGift && hasNonStackableDiscountApplied(cart);
      const isRedeemed = state.hasOfferedProduct || hasExpectedDiscountApplied(cart, offer);
      const canShowProgress = isFreeGift && offer.has_product_qualifiers !== true;
      const shouldShow = !isRedeemed && !hasBlockedDiscount && (canShowProgress || state.eligible);
      const preHeading = offerEl.querySelector('[data-cart-offer-pre-heading]');
      const unlockedHeading = offerEl.querySelector('[data-cart-offer-heading]');
      const remainingEl = offerEl.querySelector('[data-cart-offer-remaining]');
      const btn = offerEl.querySelector('[data-cart-promotional-offer-accept]');

      offerEl.classList.add('hidden');
      if (!shouldShow) return false;

      if (isFreeGift && !state.eligible) {
        preHeading?.classList.remove('hidden');
        unlockedHeading?.classList.add('hidden');
        btn?.classList.add('is-hidden');
        if (btn) btn.disabled = true;

        if (remainingEl) {
          remainingEl.textContent = formatMoney(
            Math.max(0, Number(offer.minimum_spend_cents || 0) - state.qualifyingSubtotalCents)
          );
        }
        return true;
      }

      preHeading?.classList.add('hidden');
      unlockedHeading?.classList.remove('hidden');
      btn?.classList.remove('is-hidden');
      if (btn) btn.disabled = false;
      return true;
    }

    function applyCartPromotionalOfferPresentation(offers) {
      const eligibleOffers = offers.filter((offer) => offer.shouldDisplay);
      const featuredOffer = eligibleOffers.length === 1
        ? eligibleOffers[0]
        : eligibleOffers.find(
            (offer) => !dismissedPromotionalOfferHandles.has(offer.handle)
          );
      const secondaryOffers = eligibleOffers.filter(
        (offer) => offer !== featuredOffer
      );
      const toggle = cartDrawer.querySelector('[data-cart-promotional-offers-toggle]');
      const toggleLabel = toggle?.querySelector(
        '[data-cart-promotional-offers-toggle-label]'
      );
      const remainingCount = secondaryOffers.length;

      eligibleOffers.forEach((offer) => {
        const offerEl = cartDrawer.querySelector(
          `[data-cart-promotional-offer="${CSS.escape(offer.handle)}"]`
        );
        if (!offerEl) return;

        const isFeatured = offer === featuredOffer;
        const secondaryIndex = secondaryOffers.indexOf(offer);
        offerEl.style.order = String(isFeatured ? 0 : secondaryIndex + 2);
        offerEl.classList.toggle('cart-drawer__promotional-offer--featured', isFeatured);
        offerEl.classList.toggle(
          'cart-drawer__promotional-offer--secondary',
          !isFeatured
        );
        offerEl.classList.toggle(
          'hidden',
          !isFeatured && !promotionalOffersExpanded
        );
        offerEl.querySelectorAll('[data-cart-promotional-offer-dismiss]')
          .forEach((button) => {
            button.hidden = !isFeatured || eligibleOffers.length === 1;
          });
      });

      if (!toggle || !toggleLabel) return;

      toggle.hidden = remainingCount === 0;
      toggle.style.order = featuredOffer ? '1' : '0';
      toggle.setAttribute('aria-expanded', String(promotionalOffersExpanded));
      toggleLabel.textContent = promotionalOffersExpanded
        ? (featuredOffer ? 'Hide other offers' : 'Hide offers')
        : `View ${remainingCount} ${featuredOffer ? 'more ' : ''}offer${remainingCount === 1 ? '' : 's'}`;
      toggle.classList.toggle('is-expanded', promotionalOffersExpanded);
    }

    function getDismissedPromotionalOfferHandles() {
      try {
        const handles = JSON.parse(
          sessionStorage.getItem('mtbd:cart-promotional-offers:dismissed') || '[]'
        );
        return new Set(Array.isArray(handles) ? handles.map(String) : []);
      } catch (error) {
        return new Set();
      }
    }

    function saveDismissedPromotionalOfferHandles() {
      try {
        sessionStorage.setItem(
          'mtbd:cart-promotional-offers:dismissed',
          JSON.stringify(Array.from(dismissedPromotionalOfferHandles))
        );
      } catch (error) {
        // The offer can still be dismissed for this cart render if storage is unavailable.
      }
    }

    async function updateCartPromotionalOffersUI() {
      const offers = getCartPromotionalOffers();
      if (!offers.length) return;

      const cart = await fetchCartJson();
      offers.forEach((offer) => {
        offer.shouldDisplay = updateCartPromotionalOfferUI(cart, offer);
      });
      applyCartPromotionalOfferPresentation(offers);
    }

    function groupPromotionalOfferItems(items) {
      const groups = new Map();

      (items || []).forEach((item) => {
        const parent = String(item.parent || item.title || 'Product').trim();
        const key = parent.toLowerCase();

        if (!groups.has(key)) {
          groups.set(key, {
            parent,
            displayProduct: item,
            items: [],
            variantIds: new Set()
          });
        }

        const group = groups.get(key);
        const variantId = String(item.variant_id || '');
        if (!variantId || group.variantIds.has(variantId)) return;

        group.variantIds.add(variantId);
        group.items.push(item);
      });

      return Array.from(groups.values()).map(({ variantIds, ...group }) => group);
    }

    function initCartPromotionalOffers() {
      const offers = getCartPromotionalOffers();
      if (!offers.length) return;

      const offersToggle = cartDrawer.querySelector(
        '[data-cart-promotional-offers-toggle]'
      );
      if (offersToggle && !offersToggle.dataset.bound) {
        offersToggle.dataset.bound = 'true';
        offersToggle.addEventListener('click', () => {
          promotionalOffersExpanded = !promotionalOffersExpanded;
          applyCartPromotionalOfferPresentation(offers);
          trackClarityCartEvent('promotional_offers_toggle', {
            expanded: promotionalOffersExpanded,
            remainingOffers: Math.max(
              0,
              offers.filter((offer) => offer.shouldDisplay).length - 1
            )
          });
        });
      }

      offers.forEach((offer) => {
        const offerEl = cartDrawer.querySelector(
          `[data-cart-promotional-offer="${CSS.escape(offer.handle)}"]`
        );
        offerEl?.querySelectorAll('[data-cart-promotional-offer-dismiss]')
          .forEach((dismissButton) => {
            if (dismissButton.dataset.bound) return;

            dismissButton.dataset.bound = 'true';
            dismissButton.addEventListener('click', () => {
              dismissedPromotionalOfferHandles.add(offer.handle);
              saveDismissedPromotionalOfferHandles();
              promotionalOffersExpanded = false;
              applyCartPromotionalOfferPresentation(offers);
            });
          });

        const btn = offerEl?.querySelector('[data-cart-promotional-offer-accept]');
        if (!btn || btn.dataset.bound) return;

        btn.dataset.bound = 'true';
        btn.addEventListener('click', async () => {
          if (btn.classList.contains('is-loading') || btn.disabled) return;

          let items = offer.group?.items || [];
          if (
            offer.offered_collection_handles?.length &&
            !offer.collectionItemsLoaded
          ) {
            btn.classList.add('is-loading');
            try {
              items = await loadCollectionOfferItems(offer);
            } catch (error) {
              console.error('Promotional collection products could not be loaded', error);
            } finally {
              btn.classList.remove('is-loading');
            }
          }

          if (!items.length) return;

          const parentGroups = groupPromotionalOfferItems(items);

          if (parentGroups.length > 1) {
            openCartPromotionalParentOverlay(offer.group, parentGroups);
            return;
          }

          if (items.length > 1) {
            openCartCrossSellOverlay({
              ...offer.group,
              parent: parentGroups[0]?.parent || offer.group.parent
            });
            return;
          }

          btn.classList.add('is-loading');
          try {
            await addPromotionalOfferVariant(items[0].variant_id, offer.handle);
            trackClarityCartEvent('promotional_offer_atc', {
              offerType: offer.offer_type,
              offerHandle: offer.handle,
              variantId: items[0].variant_id
            });
            fetchCartContent();
          } catch (error) {
            console.error('Promotional offer add failed', error);
            btn.classList.remove('is-loading');
          }
        });
      });

      updateCartPromotionalOffersUI();
    }

    ////////////////////////////////////////////////////////
    // Cart Drawer Cross-Sell Overlay (Parent Selector)
    ////////////////////////////////////////////////////////

    let cartCrossSellGroups = null;
    let cartCrossSellOverlayState = null;
    let cartPromotionalOffers = null;
    let promotionalOffersExpanded = false;
    let dismissedPromotionalOfferHandles = getDismissedPromotionalOfferHandles();

    function getCartCrossSellData() {
      if (cartCrossSellGroups) return cartCrossSellGroups;

      const root = document.querySelector('[data-cart-cross-sell-root]');
      const dataEl = root?.querySelector('[data-cart-cross-sell-data]');
      if (!dataEl) return null;

      try {
        cartCrossSellGroups = JSON.parse(dataEl.textContent || '[]');
      } catch (e) {
        console.warn('Cross-sell JSON parse failed', e);
        return null;
      }

      return cartCrossSellGroups;
    }

    function getCartProductPickerElements(group = null) {
      const isPromotionalOffer = Boolean(
        group?.offer_handle || cartCrossSellOverlayState?.offerHandle
      );
      const root = isPromotionalOffer
        ? cartDrawer.querySelector('[data-cart-promotional-offers]')
        : document.querySelector('[data-cart-cross-sell-root]');
      const overlaySelector = isPromotionalOffer
        ? '[data-cart-promotional-offer-overlay]'
        : '[data-cart-cross-sell-overlay]';
      const contentSelector = isPromotionalOffer
        ? '[data-cart-promotional-offer-overlay-content]'
        : '[data-cart-cross-sell-overlay-content]';

      return {
        overlay: root?.querySelector(overlaySelector),
        content: root?.querySelector(contentSelector)
      };
    }

    function openCartCrossSellOverlay(group) {
      const { overlay, content } = getCartProductPickerElements(group);

      if (!overlay || !content) return;

      content.innerHTML = buildCartCrossSellUI(group);
      cartCrossSellOverlayState = {
        parent: group?.parent || '',
        offerHandle: group?.offer_handle || '',
        offerType: group?.offer_type || '',
        addedToCart: false,
        closedTracked: false
      };

      overlay.hidden = false;

      // ✅ Prevent background scroll (matches your drawer pattern)
      document.body.classList.add('no-scroll');
      document.documentElement.classList.add('cart-overlay-active');

      bindOverlayAddToCart(content);
    }

    function buildCartPromotionalParentUI(group, parentGroups) {
      const cards = parentGroups.map((parentGroup, index) => {
        const item = parentGroup.displayProduct || parentGroup.items[0] || {};
        const parentImage = item.parent_image || item.image;
        const comparePrice = item.price_original
          ? `<span class="cross-sell-price-old">${escapeHtml(item.price_original)}</span>`
          : '';
        const currentPrice = item.price_final
          ? `<span class="cross-sell-price-new">${escapeHtml(item.price_final)}</span>`
          : '';

        return `
          <article class="cart-drawer__cross-sell-card cart-promotional-parent-picker__card">
            <a
              href="${escapeHtml(item.url || '#')}"
              class="cart-drawer__cross-sell-open"
              aria-label="Open ${escapeHtml(parentGroup.parent)} product page"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
                <path fill="currentColor" d="M14 3h7v7h-2V6.41l-9.29 9.3-1.42-1.42 9.3-9.29H14V3z"></path>
                <path fill="currentColor" d="M5 5h7v2H7v10h10v-5h2v7H5V5z"></path>
              </svg>
            </a>
            <div class="cart-drawer__cross-sell-image">
              ${parentImage ? `<img src="${escapeHtml(parentImage)}" alt="${escapeHtml(parentGroup.parent)}" loading="lazy">` : ''}
            </div>
            <div class="cart-drawer__cross-sell-content">
              <h4 class="cart-drawer__cross-sell-title">${escapeHtml(parentGroup.parent)}</h4>
              <div class="cart-drawer__cross-sell-price">
                ${comparePrice}${currentPrice}
              </div>
              <div class="cart-drawer__cross-sell-actions">
                <button
                  type="button"
                  class="cart-drawer__cross-sell-button"
                  data-promotional-parent-select="${index}"
                >
                  <span class="cross-sell-btn-label">+ Add</span>
                  <span class="cross-sell-btn-spinner" aria-hidden="true"></span>
                </button>
              </div>
            </div>
          </article>
        `;
      }).join('');

      return `
        <div class="cart-promotional-parent-picker">
          <div class="cart-promotional-parent-picker__header">
            <h3>${escapeHtml(group.add_label || 'Choose a product')}</h3>
          </div>
          <div class="cart-drawer__cross-sells-wrapper" data-promotional-parent-wrapper>
            <div class="cross-sell-fade cross-sell-fade--left"></div>
            <div class="cross-sell-fade cross-sell-fade--right"></div>
            <button
              type="button"
              class="cross-sell-nav cross-sell-nav--left"
              data-cross-sell-nav="left"
              aria-label="Scroll products left"
            >‹</button>
            <div
              class="cart-promotional-parent-picker__track"
              data-cross-sell-track
              aria-label="${escapeHtml(group.add_label || 'Choose a product')}"
            >
              ${cards}
            </div>
            <button
              type="button"
              class="cross-sell-nav cross-sell-nav--right"
              data-cross-sell-nav="right"
              aria-label="Scroll products right"
            >›</button>
          </div>
        </div>
      `;
    }

    function renderCartPromotionalParentUI(content, group, parentGroups) {
      content.innerHTML = buildCartPromotionalParentUI(group, parentGroups);
      cartCrossSellOverlayState.parent = '';

      requestAnimationFrame(() => {
        const wrapper = content.querySelector('[data-promotional-parent-wrapper]');
        if (wrapper) updateCrossSellNavState(wrapper);
      });

      content.querySelectorAll('[data-promotional-parent-select]').forEach((btn) => {
        btn.addEventListener('click', async () => {
          if (btn.classList.contains('is-loading')) return;

          const parentGroup = parentGroups[Number(btn.dataset.promotionalParentSelect)];
          if (!parentGroup?.items.length) return;

          cartCrossSellOverlayState.parent = parentGroup.parent;
          trackClarityCartEvent('promotional_offer_parent_select', {
            offerType: cartCrossSellOverlayState.offerType,
            offerHandle: cartCrossSellOverlayState.offerHandle,
            parent: parentGroup.parent
          });

          if (parentGroup.items.length > 1) {
            const pickerGroup = {
              ...group,
              parent: parentGroup.parent,
              items: parentGroup.items,
              return_to_parents: true
            };

            content.innerHTML = buildCartCrossSellUI(pickerGroup);
            bindOverlayAddToCart(content);
            content.querySelector('[data-promotional-parent-back]')?.addEventListener('click', () => {
              renderCartPromotionalParentUI(content, group, parentGroups);
            });
            return;
          }

          btn.classList.add('is-loading');
          try {
            const item = parentGroup.items[0];
            await addPromotionalOfferVariant(item.variant_id, group.offer_handle);
            cartCrossSellOverlayState.addedToCart = true;
            trackClarityCartEvent('promotional_offer_atc', {
              offerType: group.offer_type,
              offerHandle: group.offer_handle,
              parent: parentGroup.parent,
              variantId: item.variant_id
            });
            closeCartCrossSellOverlay();
            fetchCartContent();
          } catch (error) {
            console.error('Promotional offer add failed', error);
            btn.classList.remove('is-loading');
          }
        });
      });
    }

    function openCartPromotionalParentOverlay(group, parentGroups) {
      const { overlay, content } = getCartProductPickerElements(group);
      if (!overlay || !content) return;

      cartCrossSellOverlayState = {
        parent: '',
        offerHandle: group?.offer_handle || '',
        offerType: group?.offer_type || '',
        addedToCart: false,
        closedTracked: false
      };

      renderCartPromotionalParentUI(content, group, parentGroups);
      overlay.hidden = false;
      document.body.classList.add('no-scroll');
      document.documentElement.classList.add('cart-overlay-active');
    }

    function getSelectedCrossSellOverlayVariant() {
      const { overlay } = getCartProductPickerElements();
      if (!overlay || overlay.hidden) return {};

      const btn = overlay.querySelector('[data-overlay-add]');
      const openLink = overlay.querySelector('.cart-cross-sell-picker__open');

      return {
        parent: cartCrossSellOverlayState?.parent || '',
        offerHandle: cartCrossSellOverlayState?.offerHandle || '',
        offerType: cartCrossSellOverlayState?.offerType || '',
        variantId: btn?.dataset.variantId,
        url: openLink?.getAttribute('href') || ''
      };
    }

    function closeCartCrossSellOverlay() {
      const { overlay, content } = getCartProductPickerElements();

      if (!overlay || !content) return;
      if (overlay.hidden) return;

      if (
        cartCrossSellOverlayState &&
        !cartCrossSellOverlayState.addedToCart &&
        !cartCrossSellOverlayState.closedTracked
      ) {
        trackClarityCartEvent('cross_sell_close_without_atc', getSelectedCrossSellOverlayVariant());
        cartCrossSellOverlayState.closedTracked = true;
      }

      overlay.hidden = true;
      content.innerHTML = '';
      cartCrossSellOverlayState = null;

      // Keep scroll locked while the cart drawer itself is still open.
      if (!cartDrawer.classList.contains('open')) {
        document.body.classList.remove('no-scroll');
      }
      document.documentElement.classList.remove('cart-overlay-active');
    }

    ////////////////////////////////////////////////////////
    // Cross-sell offers – show offer when eligible, add on click
    ////////////////////////////////////////////////////////

    function parseCrossSellBadges(raw) {
      if (!raw || typeof raw !== 'string') return [];
      try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    }

    function isFinalSaleBadge(badges) {
      if (!Array.isArray(badges)) return false;
      return badges.some((badge) => {
        const text = String(badge?.text || '').toUpperCase();
        return text.includes('FINAL SALE');
      });
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function renderCrossSellBadges(badges) {
      if (!Array.isArray(badges) || !badges.length) return '';

      return badges
        .filter((badge) => badge?.text)
        .map((badge) => {
          const badgeClass = badge.class ? ` ${escapeHtml(badge.class)}` : '';
          return `<span class="badge${badgeClass}">${escapeHtml(badge.text)}</span>`;
        })
        .join('');
    }

    function buildCartCrossSellUI(group) {
      const items = group.items || [];
      if (!items.length) return '<p>No products available.</p>';

      const uniq = (arr) => [...new Set(arr)];

      const baseSizes = [
        '2XS', 'XXS', 'XS', 'XS-20', 'XS-28', 'XS/S', 'XS-S', 'S', 'S-22', 'S-28', 'S-30', 'S-31', 'S/M', 'S-M', 'M', 'M-24', 'M-32', 'M-33', 'M-34', 'M - Regular', 'M/L', 'M-L', 'L', 'L-26', 'L-34', 'L - Regular', 'L - Slim', 'L/XL', 'L-XL', 'XL', 'XL-28', 'XL-34', 'XL-36', 'XL/2XL', 'XL-2XL', '2XL', '2XL-38', 'XXL', '3XL', '3XL-40', 'XXXL', '4XL', 'XXXXL',
        'XS - 122mm', 'S - 126mm', 'M - 133mm', 'L - 122mm', 'L - 134mm', 'L - 135mm', 'XL - 137mm', 'XL - 138mm',
        'One Size Fits Most', 'OSFA',
        '3', '4', '5', '5.0', '5.5', '6', '6.0', '6.5', '7', '7.0', '7.5', '8', '8.0', '8.5', '9', '9.0', '9.5', '10', '10.0', '10C', '10.5', '11', '11.0', '11.5', '12', '12.0', '12.5', '13', '13.0', '13.5', '14', '14.0', '14.5', '15', '15.0',
        '8-10', '10-13'
      ];
      const sizeOrder = [
        ...baseSizes,
        ...["Women's", 'Youth', 'Youth -', 'Kids', 'US', 'Child', 'Toddler', "Women's US"]
          .flatMap((prefix) => baseSizes.map((size) => `${prefix} ${size}`))
      ];
      const sizeRanks = new Map(sizeOrder.map((size, index) => [size, index]));
      const sortValues = (label, values) => values.slice().sort((a, b) => {
        if (label.toLowerCase() === 'size') {
          const aRank = sizeRanks.get(a);
          const bRank = sizeRanks.get(b);
          if (aRank !== undefined && bRank !== undefined) return aRank - bRank;
          if (aRank !== undefined) return -1;
          if (bRank !== undefined) return 1;
        }
        return a.localeCompare(b);
      });

      const optionMap = (item) => {
        const map = {};
        (item.options || []).forEach((o) => {
          if (!o?.label) return;
          map[o.label] = o.value;
        });
        return map;
      };

      const prepared = items.map((item) => ({
        ...item,
        optionMap: optionMap(item)
      }));

      const allLabels = uniq(prepared.flatMap((item) => Object.keys(item.optionMap)));
      const hasTechnicalCasing = allLabels.some((label) => label.toLowerCase() === 'technical casing');
      const hasTechnicalCompound = allLabels.some((label) => label.toLowerCase() === 'technical compound');
      const labels = allLabels.filter((label) => {
        const normalizedLabel = label.toLowerCase();
        if (hasTechnicalCasing && normalizedLabel === 'casing') return false;
        if (hasTechnicalCompound && normalizedLabel === 'compound') return false;
        return true;
      });
      const labelDisplayMap = {
        'technical casing': 'Casing',
        'technical compound': 'Compound'
      };

      const state = {};
      labels.forEach((label) => {
        state[label] = label.toLowerCase() === 'size' ? '' : prepared[0].optionMap[label] || '';
      });

      const findMatch = () => {
        const exact = prepared.find((item) =>
          labels.every((label) => (item.optionMap[label] || '') === (state[label] || ''))
        );

        return exact || prepared[0];
      };

      const initial = findMatch();

      const html = `
        <div class="cart-cross-sell-picker">
          <div class="cart-cross-sell-picker__card">

            <div class="cart-cross-sell-picker__topbar">
              <div class="cart-cross-sell-picker__heading">
                ${group.return_to_parents ? '<button type="button" class="cart-cross-sell-picker__back" data-promotional-parent-back>‹ Back to products</button>' : ''}
                <h3 class="cart-cross-sell-picker__title">${escapeHtml(group.parent || initial.title || '')}</h3>
              </div>

              <a
                href="${escapeHtml(initial.url || '#')}"
                class="cart-cross-sell-picker__open"
                data-overlay-pdp-open
                aria-label="Open product page"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
                  <path fill="currentColor" d="M14 3h7v7h-2V6.41l-9.29 9.3-1.42-1.42 9.3-9.29H14V3z"></path>
                  <path fill="currentColor" d="M5 5h7v2H7v10h10v-5h2v7H5V5z"></path>
                </svg>
              </a>
            </div>

            <div class="cart-cross-sell-picker__main">
              <div class="cart-cross-sell-picker__media">
                ${
                  initial.image
                    ? `<img class="cart-cross-sell-picker__image" src="${escapeHtml(initial.image)}" alt="${escapeHtml(initial.title || '')}" loading="lazy">`
                    : ''
                }
              </div>

              <div class="cart-cross-sell-picker__details">
                <div class="cart-cross-sell-picker__filters" data-overlay-filters></div>

                <div class="cart-cross-sell-picker__price-row">
                  <span class="cart-cross-sell-picker__compare" data-compare>${escapeHtml(initial.price_original || '')}</span>
                  <span class="cart-cross-sell-picker__price" data-price>${escapeHtml(initial.price_final || '')}</span>
                  <div class="cart-cross-sell-picker__badges" data-overlay-badges>
                    ${renderCrossSellBadges(initial.badges)}
                  </div>
                </div>

                <div class="cart-cross-sell-picker__actions">
                  <button
                    type="button"
                    class="cart-cross-sell-picker__add"
                    data-overlay-add
                    data-variant-id="${escapeHtml(initial.variant_id || '')}"
                  >
                    <span class="cross-sell-btn-label">Add To Cart</span>
                    <span class="cross-sell-btn-spinner" aria-hidden="true"></span>
                  </button>
                </div>
              </div>
            </div>

          </div>
        </div>
      `;

      setTimeout(() => {
        const root = document.querySelector('.cart-cross-sell-picker');
        if (!root) return;

        const filtersEl = root.querySelector('[data-overlay-filters]');
        const priceEl = root.querySelector('[data-price]');
        const compareEl = root.querySelector('[data-compare]');
        const btn = root.querySelector('[data-overlay-add]');
        const imageEl = root.querySelector('.cart-cross-sell-picker__image');
        const badgesEl = root.querySelector('[data-overlay-badges]');
        const openLinkEl = root.querySelector('.cart-cross-sell-picker__open');

        if (openLinkEl && !openLinkEl.dataset.clarityBound) {
          openLinkEl.dataset.clarityBound = 'true';
          openLinkEl.addEventListener('click', () => {
            trackClarityCartEvent('cross_sell_pdp_open', getSelectedCrossSellOverlayVariant());
          });
        }

        const rowSelects = new Map();

        const uniq = (arr) => [...new Set(arr)];
        const optionsData = Array.isArray(group.option_sort_order) ? group.option_sort_order : [];
        const orderLabels = (labels) => {
          return uniq(labels).filter(Boolean)
            .map((label) => ({
              label,
              sortorder: optionsData.find((option) => option.label === label)?.sortorder ?? 999,
              valueCount: uniq(prepared.map((item) => item.optionMap[label])).length
            }))
            .sort((a, b) => {
              const ignoreSingleCheck = (label) => ['style', 'colour'].includes(label.toLowerCase());
              const aSingle = a.valueCount === 1 && !ignoreSingleCheck(a.label);
              const bSingle = b.valueCount === 1 && !ignoreSingleCheck(b.label);
              if (aSingle !== bSingle) return aSingle ? 1 : -1;
              return (a.sortorder - b.sortorder) || a.label.localeCompare(b.label);
            })
            .map((option) => option.label);
        };

        const orderedLabels = orderLabels(labels);

        const filterItems = (criteria) => {
          return prepared.filter((item) =>
            Object.entries(criteria).every(([k, v]) => (item.optionMap[k] || '') === v)
          );
        };

        const allowedValuesFor = (label, criteria) => {
          return sortValues(label, uniq(
            filterItems(criteria)
              .map((item) => item.optionMap[label])
              .filter(Boolean)
          ));
        };

        const findExactMatch = () => {
          return prepared.find((item) =>
            orderedLabels.every((label) => (item.optionMap[label] || '') === (state[label] || ''))
          );
        };

        const resolveMatrix = () => {
          const resolved = { ...state };

          for (let i = 0; i < orderedLabels.length; i++) {
            const label = orderedLabels[i];
            const criteria = {};

            for (let j = 0; j < i; j++) {
              criteria[orderedLabels[j]] = resolved[orderedLabels[j]];
            }

            const allowed = allowedValuesFor(label, criteria);
            if (!allowed.length) continue;

            if (!allowed.includes(resolved[label])) {
              resolved[label] = allowed[0];
            }
          }

          orderedLabels.forEach((label) => {
            state[label] = resolved[label];
          });
        };

        const refreshAvailability = () => {
          for (let i = 0; i < orderedLabels.length; i++) {
            const label = orderedLabels[i];
            const select = rowSelects.get(label);
            if (!select) continue;

            const criteria = {};
            for (let j = 0; j < i; j++) {
              criteria[orderedLabels[j]] = state[orderedLabels[j]];
            }

            const allowed = allowedValuesFor(label, criteria);

            Array.from(select.options).forEach((opt) => {
              opt.disabled = !allowed.includes(opt.value);
            });

            if (allowed.length && !allowed.includes(select.value)) {
              select.value = allowed[0];
              state[label] = allowed[0];
            }
          }
        };

        const findMatch = () => {
          const exact = findExactMatch();
          return exact || prepared[0];
        };

        const applyMatch = (match) => {
          if (!match) return;

          if (priceEl) priceEl.textContent = match.price_final || '';

          if (compareEl) {
            compareEl.textContent = match.price_original || '';
            compareEl.style.display = match.price_original ? '' : 'none';
          }

          if (btn) {
            btn.dataset.variantId = match.variant_id || '';
            btn.dataset.crossSellBadges = JSON.stringify(Array.isArray(match.badges) ? match.badges : []);
          }

          if (imageEl) {
            imageEl.src = match.image || '';
            imageEl.alt = match.title || '';
          }

          if (openLinkEl) {
            openLinkEl.href = match.url || '#';
          }

          if (badgesEl) {
            badgesEl.innerHTML = renderCrossSellBadges(match.badges);
          }
        };

        filtersEl.innerHTML = '';

        orderedLabels.forEach((label) => {
          const values = sortValues(label, uniq(prepared.map((item) => item.optionMap[label]).filter(Boolean)));
          if (values.length <= 1) return;

          const field = document.createElement('div');
          field.className = 'cart-cross-sell-picker__field';

          const heading = document.createElement('label');
          heading.className = 'cart-cross-sell-picker__field-label';
          heading.textContent = labelDisplayMap[label.toLowerCase()] || label;

          const isCompactOption = /^(style|colou?r)$/i.test(label.trim());
          if (!isCompactOption && (heading.textContent.length > 18 || values.some((value) => value.length > 12))) {
            field.classList.add('cart-cross-sell-picker__field--wide');
          }

          const select = document.createElement('select');
          select.className = 'cart-cross-sell-picker__select';
          select.id = `cart-cross-sell-option-${rowSelects.size}`;
          heading.htmlFor = select.id;

          values.forEach((value) => {
            const opt = document.createElement('option');
            opt.value = value;
            opt.textContent = value;
            select.appendChild(opt);
          });

          select.value = state[label];

          select.addEventListener('change', () => {
            const prevState = { ...state };
            const previousMatch = findMatch();
            state[label] = select.value;

            resolveMatrix();
            refreshAvailability();

            orderedLabels.forEach((lbl) => {
              const sel = rowSelects.get(lbl);
              if (sel && sel.value !== state[lbl]) {
                sel.value = state[lbl];
              }
            });

            const nextMatch = findMatch();
            applyMatch(nextMatch);

            trackClarityCartEvent('cross_sell_variant_change', {
              parent: group.parent || '',
              optionName: label,
              previousValue: prevState[label] || '',
              value: state[label] || '',
              previousVariantId: previousMatch?.variant_id,
              variantId: nextMatch?.variant_id,
              productId: nextMatch?.product_id,
              sku: nextMatch?.sku
            });
          });

          field.appendChild(heading);
          field.appendChild(select);
          filtersEl.appendChild(field);
          rowSelects.set(label, select);
        });

        resolveMatrix();
        refreshAvailability();

        orderedLabels.forEach((label) => {
          const select = rowSelects.get(label);
          if (select && select.value !== state[label]) {
            select.value = state[label];
          }
        });

        applyMatch(findMatch());
      }, 0);

      return html;
    }
    function bindOverlayAddToCart(container) {
      const btn = container.querySelector('[data-overlay-add]');
      if (!btn) return;

      btn.addEventListener('click', async () => {
        const variantId = btn.dataset.variantId;
        if (!variantId) return;

        if (btn.classList.contains('is-loading')) return;
        
        btn.classList.add('is-loading');

        try {
          const badges = parseCrossSellBadges(btn.dataset.crossSellBadges);
          if (cartCrossSellOverlayState?.offerHandle) {
            await addPromotionalOfferVariant(
              variantId,
              cartCrossSellOverlayState.offerHandle
            );
          } else {
            await addCrossSellVariant(variantId, 'overlay', { badges });
          }
          if (cartCrossSellOverlayState) {
            cartCrossSellOverlayState.addedToCart = true;
          }
          if (cartCrossSellOverlayState?.offerHandle) {
            trackClarityCartEvent('promotional_offer_atc', {
              offerType: cartCrossSellOverlayState.offerType,
              offerHandle: cartCrossSellOverlayState.offerHandle,
              variantId
            });
          } else {
            trackClarityCartEvent('cross_sell_atc', {
              variantId,
              position: 'overlay'
            });
          }

          closeCartCrossSellOverlay();
          fetchCartContent(); // ✅ refresh drawer (already used pattern)
        } catch (e) {
          console.error('Overlay add failed', e);
          btn.classList.remove('is-loading');
        }
      });
    }

    async function addCrossSellVariant(variantId, position, meta = {}) {
      const properties = {
        _cart_upsell: `position:${position}`
      };

      if (isFinalSaleBadge(meta.badges)) {
        properties['Final Sale'] = 'No Returns*';
      }

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1,
              properties
            }
          ]
        })
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        console.warn('Cross-sell could not be added:', err);
        throw new Error('Cross-sell add failed');
      }

      return res.json();
    }

    function updateCrossSellNavState(wrapper) {
      const track = wrapper.querySelector('[data-cross-sell-track]');
      const leftBtn = wrapper.querySelector('[data-cross-sell-nav="left"]');
      const rightBtn = wrapper.querySelector('[data-cross-sell-nav="right"]');
      const leftFade = wrapper.querySelector('.cross-sell-fade--left');
      const rightFade = wrapper.querySelector('.cross-sell-fade--right');

      if (!track || !leftBtn || !rightBtn) return;

      const scrollLeft = track.scrollLeft;
      const maxScroll = track.scrollWidth - track.clientWidth;

      const atStart = scrollLeft <= 5;
      const atEnd = scrollLeft >= maxScroll - 5;
      const hasOverflow = track.scrollWidth > track.clientWidth;

      /* Arrow states */
      leftBtn.classList.toggle('is-disabled', atStart);
      rightBtn.classList.toggle('is-disabled', atEnd);

      /* Fade states */
      if (leftFade) {
        leftFade.classList.toggle('is-visible', hasOverflow && !atStart);
      }

      if (rightFade) {
        rightFade.classList.toggle('is-visible', hasOverflow && !atEnd);
      }

      /* Hide arrows if there is nothing to scroll */
      if (!hasOverflow) {
        leftBtn.style.display = 'none';
        rightBtn.style.display = 'none';
      } else {
        leftBtn.style.display = '';
        rightBtn.style.display = '';
      }
    }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartDrawer, { once: true });
} else {
  initCartDrawer();
}
